import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

export const getCookie = name => Cookies.get(name);

export const useFlushStoreCookie = (apolloClient?: ApolloClient<NormalizedCacheObject>) => {
  const [flushed, setFlushed] = useState(false);

  useEffect(() => {
    const flushStoreCookie = getCookie('discovery-flush-store');
    if (flushStoreCookie === 'true' && apolloClient) {
      Cookies.remove('discovery-flush-store');
      apolloClient.clearStore();

      setFlushed(true);
    }
    if (flushed) {
      window.location.reload();
    }
  }, [apolloClient]);

  return { flushed };
};
